import React from "react";
import {
  Card,
  CardActions,
  CardContent,
  IconButton,
  Typography,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/DeleteOutline";
import { useTranslation } from "react-i18next";

import { CorporateBrandAssetDto } from "../types";

interface ModelCardProps {
  model: CorporateBrandAssetDto;
  onEdit: (model: CorporateBrandAssetDto) => void;
  onDelete: (model: CorporateBrandAssetDto) => void;
}

const ModelCard: React.FC<ModelCardProps> = ({ model, onEdit, onDelete }) => {
  const { t } = useTranslation(["corporate-brand-asset"]);
  return (
    <Card sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
      <CardContent sx={{ flexGrow: 1 }}>
        <Typography variant="h6" sx={{ mb: 1 }}>
          {model.name}
        </Typography>
      </CardContent>
      <CardActions sx={{ justifyContent: "flex-end" }}>
        <IconButton
          aria-label={t("actions.edit") || "edit"}
          onClick={() => onEdit(model)}
        >
          <EditIcon />
        </IconButton>
        <IconButton
          aria-label={t("actions.delete") || "delete"}
          color="error"
          onClick={() => onDelete(model)}
        >
          <DeleteIcon />
        </IconButton>
      </CardActions>
    </Card>
  );
};

export default ModelCard;
